{
  "version": 1,
  "asset_id": "a10f56b8-86ae-4d51-9f73-1df57f1a7c8a",
  "project_id": "115256dd-a6cc-4bc1-95c1-d787d4c0e481",
  "url": "/__l5e/assets-v1/a10f56b8-86ae-4d51-9f73-1df57f1a7c8a/accessories-card.webp",
  "r2_key": "a/v1/115256dd-a6cc-4bc1-95c1-d787d4c0e481/a10f56b8-86ae-4d51-9f73-1df57f1a7c8a/accessories-card.webp",
  "original_filename": "accessories-card.webp",
  "size": 53498,
  "content_type": "image/webp",
  "created_at": "2026-06-27T00:29:51Z"
}
